import Vue from 'vue';
import Vuex from 'vuex';
import Vuetify from 'vuetify';
import SupplierPublicSearch from './SupplierPublicSearch.vue';
import store from '@/store';
import router from '@/router';
import '@/registerServiceWorker';
import 'vuetify/dist/vuetify.min.css';
import VueEvents from 'vue-events';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import { library } from '@fortawesome/fontawesome-svg-core';
// import * as faicons from '@fortawesome/free-solid-svg-icons';
import { faBriefcase, faCalendar, faSearch, faEnvelope, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueSweetalert2 from 'vue-sweetalert2';
import Vuelidate from 'vuelidate';
import 'vuetify-datetime-picker/src/stylus/main.styl';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
    debug: true,
    dsn: 'https://3a902b95cb4d422389a834632d2bfbbf@sentry.strategenics.com.au/27',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    beforeSend(event) {
        console.log(event);
        return null;
    },
});

library.add(faBriefcase);
library.add(faCalendar);
library.add(faSearch);
library.add(faEnvelope);
library.add(faQuestionCircle);

Vue.prototype.$log = console.log.bind(console);

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(Vuetify);
Vue.use(VueSweetalert2);
Vue.use(VueEvents);
Vue.use(Vuelidate);

Vue.use(VueGoogleMaps, {
    load: {
        // Google API key
        key: 'AIzaSyDvErfjIlnf2EERzvnFyNzP1M8O6Tdejkg',
        // Enable more Google Maps libraries here
        libraries: ['places'],
        // Use new renderer
        useBetaRenderer: false,
    },
});

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('GmapCluster', GmapCluster);

new Vue({
    router,
    store,
    render: (h) => h(SupplierPublicSearch),
}).$mount('#supplier_search');
